import { IAddressEntity } from '../../models/address';
import {
  IAppointmentBase,
  IAppointmentProductBase,
} from '../../models/appointments';
import { IFeatureGroupBase } from '../../models/features';
import { IUserAssignmentBase, IUserBase } from '../../models/users';
import { IVentureBase } from '../../models/ventures';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IDetailedAppointmentVenture extends IVentureBase {
  address: IAddressEntity;
}

interface IDetailedUserAssignment extends IUserAssignmentBase {
  featureGroup: IFeatureGroupBase;
}

interface IDetailedAppointmentUser extends IUserBase {
  userAssignments: IDetailedUserAssignment[];
}

export interface IDetailedAppointment extends IAppointmentBase {
  user: IDetailedAppointmentUser;
  products: IAppointmentProductBase[];
  venture: IDetailedAppointmentVenture;
}

export const showAppointmentsService = async (
  appointmentId: string,
): Promise<IDetailedAppointment> => {
  const { data } = await jhsfBookingsApi.get<IDetailedAppointment>(
    `/appointments/${appointmentId}`,
  );

  return data;
};
